import React from 'react';
import './KitTecnicoSkeleton.css';

const Bone = ({ w, h = 10, r = 6, className = '' }) => (
  <span className={`kit-sk-bone ${className}`} style={{ width: w, height: h, borderRadius: r }} />
);

/** Lista inicial: cabeçalho de seção + grade de cards de técnico. */
export function KitListSkeleton({ cards = 9 }) {
  return (
    <div className="kit-sk kit-sk-list" role="status" aria-live="polite" aria-label="Carregando kits">
      <div className="kit-sk-section-head">
        <Bone w={110} h={11} />
        <Bone w={22} h={16} r={999} />
        <span className="kit-sk-line" />
      </div>
      <div className="kit-sk-grid">
        {Array.from({ length: cards }).map((_, i) => (
          <div key={i} className="kit-sk-card">
            <div className="kit-sk-row">
              <Bone w={36} h={36} r={999} />
              <div className="kit-sk-col">
                <Bone w="62%" h={11} />
                <Bone w="44%" h={8} />
              </div>
              <Bone w={84} h={18} r={999} />
            </div>
            <div className="kit-sk-row">
              <Bone w={40} h={22} r={6} />
              <Bone w={70} h={9} />
              <Bone w={34} h={9} className="kit-sk-push" />
            </div>
            <Bone w="100%" h={6} r={999} />
            <div className="kit-sk-row">
              <Bone w={58} h={18} r={999} />
              <Bone w={46} h={18} r={999} />
            </div>
            <div className="kit-sk-row kit-sk-foot">
              <div className="kit-sk-col">
                <Bone w={70} h={7} />
                <Bone w={56} h={9} />
              </div>
              <div className="kit-sk-col">
                <Bone w={62} h={7} />
                <Bone w={56} h={9} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/** Linhas de tabela (Peças do Kit / Movimentações), abaixo do cabeçalho real. */
export function KitTableSkeletonRows({ rows = 7 }) {
  return (
    <div className="kit-sk" role="status" aria-live="polite" aria-label="Carregando">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="kit-sk-tr">
          <Bone w={34} h={34} r={8} />
          <div className="kit-sk-col kit-sk-col--main">
            <Bone w={`${46 + ((i * 13) % 30)}%`} h={10} />
            <Bone w="32%" h={8} />
          </div>
          <Bone w={64} h={9} />
          <Bone w={40} h={9} />
          <Bone w={72} h={18} r={999} />
          <Bone w={60} h={9} />
        </div>
      ))}
    </div>
  );
}

/** Cards de pedidos (Aguardando coleta). */
export function KitPedidosSkeleton({ cards = 3 }) {
  return (
    <div className="kit-sk kit-sk-pedidos" role="status" aria-live="polite" aria-label="Carregando pedidos">
      {Array.from({ length: cards }).map((_, i) => (
        <div key={i} className="kit-sk-pedido">
          <div className="kit-sk-row kit-sk-pedido-head">
            <Bone w={8} h={8} r={999} />
            <Bone w={80} h={11} />
            <Bone w={110} h={18} r={999} />
            <Bone w={90} h={9} className="kit-sk-push" />
          </div>
          {Array.from({ length: 2 + (i % 2) }).map((__, j) => (
            <div key={j} className="kit-sk-row kit-sk-pedido-item">
              <Bone w="38%" h={9} />
              <Bone w={60} h={9} />
              <Bone w={30} h={9} className="kit-sk-push" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
